import React from 'react'
import { Typewriter } from 'react-simple-typewriter';
import image from "./../../assets/me.png";
import {TiSocialLinkedinCircular}  from "react-icons/ti";
import {VscGithub } from "react-icons/vsc"
import { CiFacebook } from "react-icons/ci";

import { Link } from 'react-router-dom';
import { BiDownload } from "react-icons/bi";
import { BsGithub } from "react-icons/bs";
import resume from '../../assets/Resume.pdf'
import useTitle from '../../hooks/UseTitle';

const Home = () => {
  useTitle('Home')
  return (
    <div className=' min-h-screen grid place-content-center max-w-screen-xl mx-auto'>
       <div className=" grid place-content-center h-screen md:text-center md:m-auto p-3  ">
            <div className='grid justify-self-center '><img className=' rounded-full  ' src={image} alt="" /></div>
       <span className=' text-2xl md:text-5xl font-bold p-3  '>  Hi, I am  <span className='text-neutral'>
       <Typewriter cursorBlinking cursorColor='#70acc7'
            words={['Fahmida Tasmia','Forntend Developer', 'MERN Stack Developer', 'React Developer']}
            loop={100}
            cursor
            cursorStyle='|'
            typeSpeed={60}
            deleteSpeed={80}
            delaySpeed={1000}
            
          /></span> </span>
         <p className='text-gray-400  my-8 text-xl m-auto hidden md:block text-center  ' data-aos="fade-up">I am a proactive and innovative frontend web developer who is passionate about my work. I possess excellent teamwork and communication skills and have a natural ability to quickly learn new skills. Additionally, I am always eager to try out and master emerging technologies.</p>
        <p className='text-gray-400 text-justify p-3 mt-2 mb-4 text-sm md:hidden block' data-aos="fade-up">I am a proactive and innovative frontend web developer who is passionate about my work. I possess excellent teamwork and communication skills and have a natural ability to quickly learn new skills. Additionally, I am always eager to try out and master emerging technologies.</p>
        <div className='flex justify-center gap-5'>
        <a href={resume} download="resume">
        <button className="btn hover:duration-150  gap-2 rounded-full hover:border-2 hover:bg-transparent text-white hover:text-black  "><BiDownload></BiDownload>  Resume</button>
        </a>
        <a href="https://github.com/FahmidaTasmia">
        <button className="btn gap-2 rounded-full hover:duration-150  bg-transparent  border-2 hover:bg-neutral hover:text-white">
            <BsGithub></BsGithub> Github
        </button>
        </a>
        
        </div>
    
    <div className='grid grid-cols-2 md:visible invisible' data-aos="fade-down">
    <div className=''>
     <div className=''> <a href="https://github.com/FahmidaTasmia"> <VscGithub className='text-neutral text-2xl hover:scale-110 duration-500 ease-in-out'></VscGithub></a></div>
      <div className='my-3' ><a href="https://www.facebook.com/fahmidaTasmia76/"> <CiFacebook className='text-neutral text-2xl hover:scale-110 duration-500 ease-in-out'></CiFacebook></a></div>
      <div ><a href="https://www.linkedin.com/in/fahmida-tasmia/"> <  TiSocialLinkedinCircular className='text-neutral text-2xl hover:scale-110 duration-500 ease-in-out'></ TiSocialLinkedinCircular></a></div>

      <div className='mt-2 h-12 w-0.5 bg-neutral grid content-center mx-2'> </div>
    </div>

    {/* ....lets talk */}

   <div className='grid place-content-end'>
    <p className='rotate-90 text-neutral hover:scale-110 duration-500 ease-in-out '><Link to='/contact'>Let's Talk</Link></p>
    <div className='my-4'></div>
    <div className=' h-12 w-0.5 bg-neutral mx-auto  '> </div>
   </div>
   

    </div>

   
      </div>
    </div>
  )
}

export default Home